import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { combineLatest } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';
import { selectCurrentDomainId } from '../../store/entities/domains/domains.selectors';
import {
  selectIsAccountLevel,
  selectAccountUuid,
} from '../../store/entities/user/user.selectors';

export const domainInterceptor: HttpInterceptorFn = (req, next) => {
  const store = inject(Store);

  return combineLatest([
    store.select(selectCurrentDomainId),
    store.select(selectIsAccountLevel),
    store.select(selectAccountUuid),
  ]).pipe(
    take(1),
    switchMap(([domainId, isAccountLevel, accountUuid]) => {
      const headers: Record<string, string> = {};

      if (domainId) {
        headers['X-Domain'] = domainId;
      }

      if (isAccountLevel && accountUuid) {
        headers['X-Account'] = accountUuid;
      }

      // Only clone request if we have headers to add
      if (Object.keys(headers).length > 0) {
        const clonedReq = req.clone({
          setHeaders: headers,
        });

        return next(clonedReq);
      }

      return next(req);
    })
  );
};

